import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const VISITOR_STORAGE_KEY = 'sc_landing_demo_visitor';

/**
 * Stable anonymous id for this browser (used to count unique demo video views).
 */
function getOrCreateVisitorId() {
  if (typeof window === 'undefined') return null;
  try {
    let id = window.localStorage.getItem(VISITOR_STORAGE_KEY);
    if (id && /^[a-zA-Z0-9_-]{8,64}$/.test(id)) return id;
    id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID().replace(/-/g, '')
        : `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
    window.localStorage.setItem(VISITOR_STORAGE_KEY, id);
    return id;
  } catch {
    return null;
  }
}

/**
 * Each time the homepage demo video starts playing (including replay after pause).
 * Cloud Function → Firestore `analytics/landingDemoVideo`
 * (`playCount` always; `uniqueViewCount` once per browser via visitorId).
 */
export async function recordLandingDemoVideoPlay() {
  if (typeof window === 'undefined') return;
  try {
    const visitorId = getOrCreateVisitorId();
    const fn = httpsCallable(functions, 'recordLandingDemoVideoPlay');
    await fn(visitorId ? { visitorId } : {});
  } catch (e) {
    console.warn('recordLandingDemoVideoPlay failed', e);
  }
}
